export default {
  getList: (state) => state.list,
  getPageInfo: (state) => state.pageInfo,
  getDetail: (state) => state.detail,
  getMainList: (state) => state.mainList,
  getMainPageInfo: (state) => state.mainPageInfo,
};
